export default __webpack_public_path__ + "static/media/deposit-emptystate.ebb67709.svg";